import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "font-medium text-sm hidden lg:block" }
const _hoisted_3 = { class: "flex items-center border-b border-gray-200 dark:border-gray-600 pb-[12px] mx-[20px] mb-[10px]" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "block text-black dark:text-white font-medium" }
const _hoisted_6 = { class: "block text-xs text-gray-500 dark:text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createBlock(_component_Menu, {
    as: "div",
    class: "relative profile-menu mx-[8px] md:mx-[10px] lg:mx-[12px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0"
  }, {
    default: _withCtx(({ close }) => [
      _createVNode(_component_MenuButton, { class: "admin-profile-btn flex items-center px-3 py-2 rounded-xl text-gray-600 hover:text-gray-700 dark:text-white/90 dark:hover:text-white transition-all duration-300 shadow-md hover:shadow-lg backdrop-blur-sm hover:scale-105 bg-white dark:bg-gradient-to-br dark:from-[#007aff] dark:to-[#5856d6] border border-black/10 dark:border-white/20" }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.profilePicture,
            class: "w-8 h-8 rounded-full mr-2 border-2 border-white/20 shadow-lg",
            alt: "user-profile-image"
          }, null, 8, _hoisted_1),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.userName), 1),
          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ri-arrow-down-s-line text-sm ml-1" }, null, -1))
        ]),
        _: 1,
        __: [0]
      }),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "transform opacity-0 scale-95",
        "enter-to-class": "transform opacity-100 scale-100",
        "leave-active-class": "transition ease-in duration-75",
        "leave-from-class": "transform opacity-100 scale-100",
        "leave-to-class": "transform opacity-0 scale-95"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_MenuItems, { class: "bg-white dark:bg-gray-800 backdrop-blur-xl shadow-2xl border border-gray-200 dark:border-gray-700 py-6 absolute mt-3 w-[220px] z-[10000] top-full ltr:right-0 rtl:left-0 rounded-2xl focus:outline-hidden overflow-hidden" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _ctx.profilePicture,
                  class: "rounded-full w-[31px] h-[31px] ltr:mr-[9px] rtl:ml-[9px] border-2 border-primary-200 inline-block",
                  alt: "user-profile-image"
                }, null, 8, _hoisted_4),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.userFullName), 1),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.userRole), 1)
                ])
              ]),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/apps/chat",
                    class: "block relative py-[7px] ltr:pl-[50px] ltr:pr-[20px] rtl:pr-[50px] rtl:pl-[20px] text-gray-700 dark:text-gray-300 transition-all hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg mx-2",
                    exact: "",
                    onClick: ($event: any) => (close())
                  }, {
                    default: _withCtx(() => [
                      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "material-symbols-outlined top-1/2 -translate-y-1/2 !text-[22px] absolute ltr:left-[20px] rtl:right-[20px]" }, " chat ", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('navbar.messages')), 1)
                    ]),
                    _: 2,
                    __: [1]
                  }, 1032, ["onClick"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/apps/to-do-list",
                    class: "block relative py-[7px] ltr:pl-[50px] ltr:pr-[20px] rtl:pr-[50px] rtl:pl-[20px] text-gray-700 dark:text-gray-300 transition-all hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg mx-2",
                    exact: "",
                    onClick: ($event: any) => (close())
                  }, {
                    default: _withCtx(() => [
                      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined top-1/2 -translate-y-1/2 !text-[22px] absolute ltr:left-[20px] rtl:right-[20px]" }, " format_list_bulleted ", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('navbar.myTask')), 1)
                    ]),
                    _: 2,
                    __: [2]
                  }, 1032, ["onClick"])
                ])
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "border-t border-gray-200 dark:border-gray-600 mx-[20px] my-[9px]" }, null, -1)),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/settings/account-settings",
                    class: "block relative py-[7px] ltr:pl-[50px] ltr:pr-[20px] rtl:pr-[50px] rtl:pl-[20px] text-gray-700 dark:text-gray-300 transition-all hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg mx-2",
                    exact: "",
                    onClick: ($event: any) => (close())
                  }, {
                    default: _withCtx(() => [
                      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "material-symbols-outlined top-1/2 -translate-y-1/2 !text-[22px] absolute ltr:left-[20px] rtl:right-[20px]" }, " settings ", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('common.settings')), 1)
                    ]),
                    _: 2,
                    __: [3]
                  }, 1032, ["onClick"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/authentication/lock-screen",
                    class: "block relative py-[7px] ltr:pl-[50px] ltr:pr-[20px] rtl:pr-[50px] rtl:pl-[20px] text-gray-700 dark:text-gray-300 transition-all hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg mx-2",
                    exact: "",
                    onClick: ($event: any) => {_ctx.handleLockScreen(); close()}
                  }, {
                    default: _withCtx(() => [
                      _cache[4] || (_cache[4] = _createElementVNode("i", { class: "material-symbols-outlined top-1/2 -translate-y-1/2 !text-[22px] absolute ltr:left-[20px] rtl:right-[20px]" }, " lock ", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('navbar.lockScreen')), 1)
                    ]),
                    _: 2,
                    __: [4]
                  }, 1032, ["onClick"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/authentication/logout",
                    class: "block relative py-[7px] ltr:pl-[50px] ltr:pr-[20px] rtl:pr-[50px] rtl:pl-[20px] text-red-500 dark:text-red-400 transition-all hover:text-red-700 dark:hover:text-red-300 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg mx-2",
                    exact: "",
                    onClick: ($event: any) => (close())
                  }, {
                    default: _withCtx(() => [
                      _cache[5] || (_cache[5] = _createElementVNode("i", { class: "material-symbols-outlined top-1/2 -translate-y-1/2 !text-[22px] absolute ltr:left-[20px] rtl:right-[20px] text-red-500 dark:text-red-400" }, " logout ", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('common.logout')), 1)
                    ]),
                    _: 2,
                    __: [5]
                  }, 1032, ["onClick"])
                ])
              ])
            ]),
            _: 2,
            __: [6]
          }, 1024)
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }))
}